import styled from "styled-components";
export const TextEditorStyled = styled.div`
  
`;
